export default __webpack_public_path__ + "static/media/PH.beb5ee03.svg";